import { residentDictionaryAPI } from "@/views/ResidentDictionary/services/api";

export const residentColumns = [
  {
    name: "resident_id",
    label: "ID",
    align: "center",
    field: "resident_id",
    sortable: false,
  },
  {
    name: "resident_name",
    label: "Название ЖК",
    align: "left",
    field: "resident_name",
    sortable: true,
  },
  {
    name: "sync_binding",
    label: "Привязка квартир",
    align: "center",
    field: "sync_binding",
    sortable: false,
  },
  {
    name: "resident_class_name",
    label: "Класс ЖК",
    align: "left",
    field: "resident_class_name",
    sortable: true,
  },
  {
    name: "resident_address",
    label: "Адрес",
    align: "left",
    field: "resident_address",
    sortable: true,
  },
  {
    name: "entrances",
    label: "Подъезды",
    align: "center",
    field: "entrances",
    sortable: false,
  },
  {
    name: "actions",
    label: "Действия",
    align: "center",
    field: "actions",
    sortable: false,
  },
];

export const getResidentList = async (params) => {
  try {
    const res = await residentDictionaryAPI.read(params);
    return res?.data;
  } catch (e) {}
};

export const getResidentItem = async (residentId) => {
  try {
    const res = await residentDictionaryAPI.get(residentId);
    return res?.data?.[0];
  } catch (e) {}
};

export const saveResidentItem = async (payload) => {
  const res = await residentDictionaryAPI.save(payload);
  return res;
};

export const deleteResidentItem = async (residentId) => {
  try {
    const res = await residentDictionaryAPI.delete(residentId);
    return res;
  } catch (e) {}
};

export const getResidentClasses = async () => {
  try {
    const res = await residentDictionaryAPI.readClasses();
    return res?.data;
  } catch (e) {}
};

export const getResidentCities = async () => {
  try {
    const res = await residentDictionaryAPI.readCities();
    return res?.data || res;
  } catch (e) {
    console.error("Error loading cities:", e);
    return [];
  }
};

export const getEntrancesData = async (residentGuid) => {
  try {
    const res = await residentDictionaryAPI.entrancesRead(residentGuid);
    return res?.data;
  } catch (e) {
    console.error("Error loading entrances:", e);
    return [];
  }
};

export const getEntrancesList = async (residentGuid) => {
  try {
    const res = await residentDictionaryAPI.entrancesList(residentGuid);
    return res?.data;
  } catch (e) {
    console.error("Error loading entrances list:", e);
    return [];
  }
};

export const saveEntrance = async (payload) => {
  try {
    const res = await residentDictionaryAPI.entranceSave(payload);
    return res;
  } catch (e) {
    console.error("Error saving entrance:", e);
    throw e;
  }
};

export const deleteEntrance = async (payload) => {
  try {
    const res = await residentDictionaryAPI.entranceDelete(payload);
    return res;
  } catch (e) {
    console.error("Error deleting entrance:", e);
    throw e;
  }
};

export const deleteFloor = async (payload) => {
  try {
    const res = await residentDictionaryAPI.floorDelete(payload);
    return res;
  } catch (e) {
    console.error("Error deleting floor:", e);
    throw e;
  }
};

export const getResidentsForBind = async (residentId) => {
  try {
    const res = await residentDictionaryAPI.readForBind(residentId);
    return res?.data || [];
  } catch (e) {
    console.error("Error loading residents for bind:", e);
    return [];
  }
};

export const copyEntranceFlats = async (payload) => {
  try {
    const res = await residentDictionaryAPI.entranceCopy(payload);
    return res;
  } catch (e) {
    console.error("Error copying entrance flats:", e);
    throw e;
  }
};

